import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import CustomLookupFieldPicker from './CustomLookupFieldPicker'
import CustomerPicker from '@/widgets/CustomerPicker'

export default function CustomLookupField({
	fieldSchema, // field schema
	fieldValue, 
	onChange,
	onItemSelected,
	presetFieldName,
	presetFieldLabel,
	presetFieldValue,
}) {
	const { t } = useTranslation()
	// console.log(`TCL -> LookupField.jsx:54 -> LookupField -> fieldSchema:`, fieldSchema)
	// console.log(`TCL -> LookupField.jsx:54 -> LookupField -> fieldValue:`, fieldValue)
	// console.log(`TCL -> CustomLookupField.jsx:22 -> CustomLookupField -> fieldSchema.name:`, fieldSchema.name)
	// console.log(`TCL -> CustomLookupField.jsx:22 -> CustomLookupField -> presetFieldName:`, presetFieldName)
	// console.log(`TCL -> CustomLookupField.jsx:22 -> CustomLookupField -> presetFieldLabel:`, presetFieldLabel)
	// console.log(`TCL -> CustomLookupField.jsx:22 -> CustomLookupField -> presetFieldValue:`, presetFieldValue)
	const collectionName = fieldSchema.lookupCollectionName;
	const collectionId = fieldSchema.lookupCollectionId;

	const [isOpen, setIsOpen] = useState(false)
	const [selectedValue, setSelectedValue] = useState(fieldValue?.fieldValue || '-')

	useEffect(() => {
		if (fieldValue?.fieldName) {
			setSelectedValue(fieldValue.fieldName)
		} else {
			setSelectedValue('-')
		}
	}, [fieldValue])

	useEffect(() => {
		// If this field matches the preset field name, set its value
		if (presetFieldName === fieldSchema.name && presetFieldValue && presetFieldLabel) {
			// console.log(`Will preset ${fieldSchema.name} with value ${presetFieldValue} and label ${presetFieldLabel}`)
			let presetValueObject = {
				fieldName: presetFieldLabel,
				fieldValue: presetFieldValue
			}
			onChange(fieldSchema.name, presetValueObject)
			setSelectedValue(presetFieldLabel)
		}
	}, [presetFieldValue]) // eslint-disable-line react-hooks/exhaustive-deps

	const handleSelect = (item) => {
		let selectedItem = {
			fieldName: item[fieldSchema.lookupDisplayField] || '-',
			fieldValue: item[fieldSchema.lookupLinkField],
		}
		onChange?.(fieldSchema.name, selectedItem)
		// console.log(`TCL -> LookupField.jsx:67 -> handleSelect -> selectedItem:`, selectedItem)
		setIsOpen(false);
		onItemSelected?.()
	}

	// console.log(`TCL -> CustomLookupField.jsx:38 -> CustomLookupField -> collectionName:`, collectionName)

	return (
		<div className="col-span-full">
			<label htmlFor={fieldSchema.name} className="block text-sm/6 font-medium text-gray-900">{fieldSchema.name}</label>
			<div className="mt-2 grid grid-cols-1 gap-2">
				<div className="col-start-1 row-start-1 w-full rounded-md border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900">
					<div className="flex items-center justify-between gap-2">
						<div className="space-y-1">
							<div className="text-xs text-gray-500">{t('singleCustomCollection.form.lookup.selected')}</div>
							<div className="font-medium">{selectedValue}</div>
						</div>
						<div className="flex items-center gap-2">
							<button type="button" className="rounded-md bg-indigo-600 px-3 py-1.5 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
							onClick={() => setIsOpen(isOpen => !isOpen)}
							>{fieldSchema.lookupCollectionName ? t('singleCustomCollection.form.lookup.change') : t('singleCustomCollection.form.lookup.missingCollection')}</button>
						</div>
					</div>
				</div>

				{isOpen && (
					collectionName === 'Customers' ? (
						<CustomerPicker
							onCustomerSelect={handleSelect}
						/>
					) : (
						<CustomLookupFieldPicker
							collectionName={collectionName}
							collectionId={collectionId}
							onSelect={handleSelect}
						/>
					)
				)}
			</div>
		</div>
	)
}
